import { render, staticRenderFns } from "./she.vue?vue&type=template&id=71876fb0&scoped=true&"
import script from "./she.vue?vue&type=script&lang=ts&"
export * from "./she.vue?vue&type=script&lang=ts&"
import style0 from "./she.vue?vue&type=style&index=0&id=71876fb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71876fb0",
  null
  
)

export default component.exports